var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetPasswordPageGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 959,
    viewBox: "0 0 1440 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2569_24391)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 959,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.0198 151.489C-96.0198 151.489 171.319 107.057 340.393 196.96C521.852 293.455 684.315 361.966 828.555 358.871C962.488 355.995 1323.12 286.863 1472.3 396.313",
    stroke: "#ADBBF8",
    strokeWidth: 2.87579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.85 644.015C1490.85 644.015 1223.51 599.583 1054.44 689.487C872.979 785.978 710.515 854.499 566.274 851.397C432.342 848.521 71.7078 779.389 -77.4712 888.841",
    stroke: "#ADBBF8",
    strokeWidth: 2.87579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.89804 91.2516C-6.42051 95.3995 107.427 373.52 407.032 403.763C611.51 424.405 940.143 264.697 1069.45 200.702C1209.15 131.575 1438.73 19.9169 1587.9 129.366",
    stroke: "#ADBBF8",
    strokeWidth: 2.87579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.65 553.861C1459.18 558.009 1345.33 836.132 1045.72 866.375C841.245 887.013 512.612 727.3 383.303 663.314C243.604 594.187 14.0297 482.521 -135.154 591.974",
    stroke: "#ADBBF8",
    strokeWidth: 2.87579,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.59 353.938C1121.51 353.938 1133.6 341.846 1133.6 326.929C1133.6 312.013 1121.51 299.921 1106.59 299.921C1091.68 299.921 1079.58 312.013 1079.58 326.929C1079.58 341.846 1091.68 353.938 1106.59 353.938Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6794 590.903C94.5959 590.903 106.688 578.811 106.688 563.894C106.688 548.978 94.5959 536.885 79.6794 536.885C64.7629 536.885 52.6707 548.978 52.6707 563.894C52.6707 578.811 64.7629 590.903 79.6794 590.903Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.39 841.283C1235.07 841.283 1243.73 832.623 1243.73 821.94C1243.73 811.258 1235.07 802.598 1224.39 802.598C1213.71 802.598 1205.05 811.258 1205.05 821.94C1205.05 832.623 1213.71 841.283 1224.39 841.283Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.16 671.521C1129.79 671.521 1138.4 662.906 1138.4 652.279C1138.4 641.652 1129.79 633.037 1119.16 633.037C1108.53 633.037 1099.92 641.652 1099.92 652.279C1099.92 662.906 1108.53 671.521 1119.16 671.521Z",
    fill: "#6C7FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0298 844.791C75.657 844.791 84.2722 836.176 84.2722 825.549C84.2722 814.921 75.657 806.306 65.0298 806.306C54.4025 806.306 45.7874 814.921 45.7874 825.549C45.7874 836.176 54.4025 844.791 65.0298 844.791Z",
    fill: "#6C7FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.751 299.922C816.066 299.922 820.373 295.614 820.373 290.3C820.373 284.986 816.066 280.678 810.751 280.678C805.437 280.678 801.129 284.986 801.129 290.3C801.129 295.614 805.437 299.922 810.751 299.922Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.039 415.212C1000.35 415.212 1004.66 410.905 1004.66 405.59C1004.66 400.276 1000.35 395.968 995.039 395.968C989.724 395.968 985.417 400.276 985.417 405.59C985.417 410.905 989.724 415.212 995.039 415.212Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.926 806.306C231.24 806.306 235.548 801.998 235.548 796.684C235.548 791.37 231.24 787.062 225.926 787.062C220.612 787.062 216.304 791.37 216.304 796.684C216.304 801.998 220.612 806.306 225.926 806.306Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.65 860.829C1016.16 860.829 1022.25 854.738 1022.25 847.224C1022.25 839.709 1016.16 833.618 1008.65 833.618C1001.13 833.618 995.041 839.709 995.041 847.224C995.041 854.738 1001.13 860.829 1008.65 860.829Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.686 236.682C114.201 236.682 120.292 230.59 120.292 223.076C120.292 215.562 114.201 209.47 106.686 209.47C99.1719 209.47 93.0803 215.562 93.0803 223.076C93.0803 230.59 99.1719 236.682 106.686 236.682Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.83 334.21C1385.34 334.21 1391.43 328.119 1391.43 320.604C1391.43 313.09 1385.34 306.998 1377.83 306.998C1370.31 306.998 1364.22 313.09 1364.22 320.604C1364.22 328.119 1370.31 334.21 1377.83 334.21Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.645 223.076C440.273 223.076 448.888 214.461 448.888 203.834C448.888 193.206 440.273 184.591 429.645 184.591C419.018 184.591 410.403 193.206 410.403 203.834C410.403 214.461 419.018 223.076 429.645 223.076Z",
    fill: "#6C7FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.83 140.47C1385.41 140.47 1391.56 134.319 1391.56 126.732C1391.56 119.145 1385.41 112.994 1377.83 112.994C1370.24 112.994 1364.09 119.145 1364.09 126.732C1364.09 134.319 1370.24 140.47 1377.83 140.47Z",
    fill: "#6C7FCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2569_24391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 959,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordPageGraphic);
export default __webpack_public_path__ + "static/media/ResetPasswordPageGraphic.b91872cea878fb5f67a5f4af69c57b86.svg";
export { ForwardRef as ReactComponent };